import Sidemenu from '../components/base/sidemenu';
import AdminQna from '../components/qna/adminqna';
import './AdminQna.css';

export default function AdminQnaPage() {
  return (
    <div className="flex qna-management-layout">
      <Sidemenu />
      <main className="qna-management-content">
        <AdminQna />
      </main>
    </div>
  );
}
